import { render, staticRenderFns } from "./ExportarOctadesk.vue?vue&type=template&id=47be2d06"
import script from "./ExportarOctadesk.vue?vue&type=script&lang=ts"
export * from "./ExportarOctadesk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports